import { Context } from "@nuxt/types";

import { type UserGiftGuidesResponse } from "@/store/gift-guides/types";
import Api from "@/utils/api";

const DEFAULT_USER_GIFT_GUIDE_LIMIT = 8;

export default class GiftGuidesApi extends Api {
  readonly url = "/v3/activities/";

  constructor($axios: Context["$axios"]) {
    super("activityService", $axios);
  }

  async getFollowingGiftGuides(params: PostMeta | null) {
    return await this.request<UserGiftGuidesResponse>({
      method: "GET",
      url: `${this.url}giftguides/user`,
      params: {
        limit: params?.limit || DEFAULT_USER_GIFT_GUIDE_LIMIT,
        next: params?.next || null,
        includes: ["posts", "cover_photos", "profiles", "attributes"],
      },
    });
  }
}
